// Files a content writer sent in that nobody has opened yet (migration 064) — the day
// page's fourth kind of row.
//
// ⚠ IT IS THE ONLY SECTION ON THIS PAGE THAT IS NOT ABOUT TODAY. Meetings, tasks and lead
// follow-ups are all here because a date arrived. An upload is here because it HAPPENED
// and nobody has looked at it — it could be from this morning or from last week, and it
// stays until somebody opens it.
//
// ⚠ AND THAT IS WHY IT DOES NOT USE `DayRow`. That component's badge is the date verdict
// — red "באיחור" or amber "להיום" — and every row it draws is one or the other. An upload
// is neither: it is not late and it is not due. Passing it through DayRow would have
// forced it to claim one of two states it does not have, so it uses the same CSS frame
// with the one badge that is true of it. The geometry is shared; the words are not.
//
// It is also the only kind that arrives from OUTSIDE the office — nobody here scheduled
// it — which is precisely why it needs saying out loud.
//
// DISPLAY ONLY, like the whole page. The row links to the job; opening the file THERE is
// what clears it from this list and from the bell.
import { Link } from 'react-router-dom';
import he from '../../i18n/he';
import DateText from '../../components/DateText';

export default function DayUploads({ rows }) {
  return (
    <>
      {rows.map((row) => (
        <Link key={row.id} to={`/jobs/${row.jobId}`} className="day-row">
          <span className="day-row-head">
            <span className="swatch" style={{ background: row.client.color || 'var(--muted)' }} />
            <span className="day-row-name">{row.client.name}</span>
            {/* Green, not red or amber. Nothing is wrong — something new arrived. */}
            <span className="badge green">{he.workFiles.unseen}</span>
            <span className="day-row-date"><DateText value={row.uploadedAt} /></span>
          </span>
          {/* Who sent it and where it landed — the two facts that make it actionable. */}
          <span className="day-row-text">
            {he.workFiles.alertLine(row.uploadedBy, row.jobTitle)}
          </span>
          <span className="day-row-foot">
            <span className="muted">
              {[row.retainerTitle, row.title].filter(Boolean).join(' · ')}
            </span>
            <span className="day-row-go">{he.workFiles.alertGo}</span>
          </span>
        </Link>
      ))}
    </>
  );
}
